import React from 'react'
import {Page, SplitterSide, AlertDialog} from 'react-onsenui'
import firebase from 'firebase/app';
import 'firebase/auth';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {removeUserInfo} from "../../modules/user";
import {showToastMessage} from "../../modules/toast";
import AddUserInfoDialog from '../user/addUserInfoDialog';

import {CHECK_ANONYMOUS} from "../../modules/variable/common_variable";
import InterestingPlaceActionSheet from '../schedule/module/interestingPlaceActionSheet';
import NoticeActionSheet from '../notice/noticeActionSheet';

class SideMenu extends React.Component {
    state = {
        isToolBarOpen: false,
        addUserInfoDialog: {open: false, first: false},
        interestingPlaceActionSheet: {open: false},
        noticeActionSheet: {open: false},
        tutorialActionSheet: {open: false},
        myInfoDialog: {open: false}
    };

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
        if(!this.props.openSideMenu && nextProps.openSideMenu){
            this.showToolBar(true);
        }
    }

    showToolBar = (show) => {
        this.setState({isToolBarOpen: show});

        if(!show){
            this.props.showSideMenu(false);
        }
    };

    signOut = () => {
        firebase.auth().signOut().then(() => {
            localStorage.setItem("EVER_LOGGED_IN", "FALSE");

            let arr = [];
            for (let i = 0; i < localStorage.length; i++) {
                if (localStorage.key(i).indexOf('com.naver.nid') !== -1) {
                    arr.push(localStorage.key(i));
                }
            }

            for (let i = 0; i < arr.length; i++) {
                localStorage.removeItem(arr[i]);
            }
            this.deleteAllCookies();
            this.props.removeUserInfo();

            this.props.showToastMessage('로그아웃 하였습니다.');
            this.props.history.push('/intro');
        }).catch(function(error) {
            console.error(error);
            this.props.showToastMessage('로그아웃 과정에서 문제가 발생하였습니다.');
        });
    };

    deleteAllCookies = () => {
        let cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            let eqPos = cookie.indexOf("=");
            let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    };

    signInForAnonymousForCurrent = () => {
        firebase.auth().signOut().then(() => {
            this.props.removeUserInfo();
            this.props.history.push('/intro');
        }).catch(function(error) {
            console.error(error);
            this.props.showToastMessage('로그인 전환 과정에서 문제가 발생하였습니다.');
        });
    };

    signUpForAnonymous = () => {
        firebase.auth().signOut().then(() => {
            this.props.removeUserInfo();
            this.props.showToastMessage('네이버 아이디로 로그인 하세요.');
            this.props.history.push('/intro');
        }).catch(function(error) {
            console.error(error);
            this.props.showToastMessage('로그인 전환 과정에서 문제가 발생하였습니다.');
        });
    };

    goToScheduleList = (type, parameter) => {
        if(type === 'MINE'){
            if(CHECK_ANONYMOUS(this.props, true)){return false}
        }

        this.props.history.push({
            pathname: '/listSchedule',
            state: {type: type, parameter: parameter}
        });
    };

    goToCreateSchedule = () => {
        if(CHECK_ANONYMOUS(this.props, true)){return false}

        this.props.history.push("/createSchedule");
    };

    render() {

        return (
            <SplitterSide
                style={{boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)'}}
                side='right'
                width={200}
                collapse={true}
                swipeable={false}
                isOpen={this.state.isToolBarOpen}
                onClose={() => this.showToolBar(false)}
                onOpen={() => this.showToolBar(true)}
            >
                <Page>
                    <ul className="list list--material side-menu-menu-section">
                        <li className="list-header list-header--material">
                            메뉴
                        </li>
                        <li className="list-item list-item--material list-item--chevron" onClick={this.goToCreateSchedule} style={{backgroundColor: '#d6e9ff'}}>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">일정 만들기</div>
                            </div>
                        </li>
                        <li className="list-item list-item--material list-item--chevron" onClick={() => this.goToScheduleList('MINE', null)}>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">내가 만든 일정</div>
                            </div>
                        </li>
                        <li className="list-item list-item--material list-item--chevron" onClick={() => this.goToScheduleList('SHARE', null)}>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">공유된 일정</div>
                            </div>
                        </li>
                        {/*<li className="list-item list-item--material list-item--chevron" onClick={() => this.goToScheduleList('RECOMMEND', null)}>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">추천 일정</div>
                            </div>
                        </li>*/}
                        {/*<li className="list-item list-item--material list-item--chevron" onClick={() => this.goToScheduleList('LOCAL_PARENT', null)}>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">지역 일정</div>
                            </div>
                        </li>*/}
                        <li className="list-item list-item--material list-item--chevron" onClick={() => this.props.history.push("/favoriteSchedule")}>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">즐겨찾기 일정</div>
                            </div>
                        </li>
                        <li className="list-item list-item--material list-item--chevron list-item--chevron-up" onClick={() => this.setState({interestingPlaceActionSheet: {...this.state.interestingPlaceActionSheet, open: true}})}>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">관심 장소</div>
                            </div>
                        </li>
                        <li className="list-item list-item--material list-item--chevron list-item--chevron-up" onClick={() => this.setState({noticeActionSheet: {...this.state.noticeActionSheet, open: true}})}>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">공지 사항</div>
                            </div>
                        </li>
                        <li className="list-item list-item--material list-item--chevron" onClick={() => this.props.history.push("/inquiry")}>
                            <div className="list-item__center list-item--material__center">
                                <div className="list-item__title list-item--material__title">문의 및 제안</div>
                            </div>
                        </li>
                    </ul>


                    {
                        !this.props.userInfo.isAnonymous ?
                            <ul className="list list--material side-menu-user-section">
                                <li className="list-header list-header--material">
                                    설정
                                </li>
                                {
                                    this.props.userInfo.nickname ?
                                        <li className="list-item list-item--material list-item--chevron" onClick={() => this.setState({myInfoDialog: {...this.state.myInfoDialog, open: true}})}>
                                            <div className="list-item__center list-item--material__center">
                                                <div className="list-item__title list-item--material__title">{this.props.userInfo.nickname.length > 8 ? this.props.userInfo.nickname.substring(0,7) + '...' : this.props.userInfo.nickname}<small> 님 정보</small></div>
                                            </div>
                                        </li>
                                        :
                                        null
                                }
                                {
                                    this.props.userInfo.isSignedIn ?
                                        <li className="list-item list-item--material list-item--chevron" onClick={() => this.setState({addUserInfoDialog: {...this.state.addUserInfoDialog, open: true, first: false}})}>
                                            <div className="list-item__center list-item--material__center">
                                                <div className="list-item__title list-item--material__title">정보수정</div>
                                            </div>
                                        </li>
                                        :
                                        null
                                }
                                {
                                    this.props.userInfo.isSignedIn ?
                                        <li className="list-item list-item--material list-item--chevron" onClick={this.signOut}>
                                            <div className="list-item__center list-item--material__center">
                                                <div className="list-item__title list-item--material__title">로그아웃</div>
                                            </div>
                                        </li>
                                        :
                                        <li className="list-item list-item--material list-item--chevron" onClick={() => this.props.history.push("/intro")}>
                                            <div className="list-item__center list-item--material__center">
                                                <div className="list-item__title list-item--material__title">로그인</div>
                                            </div>
                                        </li>
                                }
                            </ul>
                            :
                            <ul className="list list--material side-menu-user-section">
                                <li className="list-header list-header--material">
                                    사용자
                                </li>
                                <li className="list-item list-item--material list-item--chevron" onClick={this.signUpForAnonymous}>
                                    <div className="list-item__center list-item--material__center">
                                        <div className="list-item__title list-item--material__title">회원가입</div>
                                    </div>
                                </li>
                                <li className="list-item list-item--material list-item--chevron" onClick={this.signInForAnonymousForCurrent}>
                                    <div className="list-item__center list-item--material__center">
                                        <div className="list-item__title list-item--material__title">로그인</div>
                                    </div>
                                </li>
                            </ul>
                    }
                </Page>

                {
                    this.state.addUserInfoDialog.open ?
                        <AddUserInfoDialog open={true} first={false} hide={() => this.setState({addUserInfoDialog: {...this.state.addUserInfoDialog, open: false}})}/>
                        :
                        null
                }

                {
                    this.state.interestingPlaceActionSheet.open ?
                        <InterestingPlaceActionSheet open={this.state.interestingPlaceActionSheet.open} importable={false} hide={() => this.setState({interestingPlaceActionSheet: {...this.state.interestingPlaceActionSheet, open: false}})}/>
                        :
                        null
                }

                {
                    this.state.noticeActionSheet.open ?
                        <NoticeActionSheet open={this.state.noticeActionSheet.open} hide={() => this.setState({noticeActionSheet: {...this.state.noticeActionSheet, open: false}})}/>
                        :
                        null
                }

                {
                    this.state.myInfoDialog.open ?
                        <AlertDialog className="user-info-alert-dialog" isOpen={this.state.myInfoDialog.open} cancelable={true} modifier={'material'}>
                            <div className="alert-dialog-title">내 정보</div>
                            <div className="alert-dialog-content">
                                <div><small>닉네임</small></div>
                                <div>{this.props.userInfo.nickname}</div>
                                <div><small>이름</small></div>
                                <div>{this.props.userInfo.name}</div>
                                <div><small>이메일</small></div>
                                <div>{this.props.userInfo.email}</div>
                                <div><small>성별</small></div>
                                <div>{this.props.userInfo.gender}</div>
                                <div><small>연령대</small></div>
                                <div>{this.props.userInfo.age}</div>
                            </div>

                            <div className="alert-dialog-footer">
                                <button className="alert-dialog-button" onClick={() => this.setState({myInfoDialog: {...this.state.myInfoDialog, open: false}})}>
                                    닫기
                                </button>
                                <button className="alert-dialog-button" onClick={() => this.setState({addUserInfoDialog: {...this.state.addUserInfoDialog, open: true, first: false}})}>
                                    정보수정
                                </button>
                            </div>
                        </AlertDialog>
                        :
                        null
                }
            </SplitterSide>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo
});

const mapDispatchToProps = dispatch => ({
    removeUserInfo: () => dispatch(removeUserInfo()),
    showToastMessage: message => dispatch(showToastMessage(message))
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(SideMenu))